import type { JSX } from 'react'

/** Loading placeholder with the job card's shape; hidden from assistive tech, still while motion is reduced. */
export default function JobCardSkeleton(): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className="flex flex-col gap-3 rounded-lg border border-border-strong bg-surface-raised p-4 motion-safe:animate-pulse"
    >
      <div className="flex items-center gap-3">
        <div className="size-10 rounded-sm bg-fill-strong" />
        <div className="h-4 flex-1 rounded-sm bg-fill-strong" />
      </div>
      <div className="h-3 w-1/2 rounded-sm bg-fill-subtle" />
      <div className="h-3 w-full rounded-sm bg-fill-subtle" />
      <div className="h-3 w-3/4 rounded-sm bg-fill-subtle" />
    </div>
  )
}
